import { PlaySolidIcon } from "@components/library/Icons";
import { YC_INTERVIEW_LINK } from "utils/constants";

export const VideoBanner = () => {
  return (
    <div className="group h-[220px] bg-[url('/assets/marketing/interview-image@6x.jpg')] bg-cover bg-[center_top_30%] transition-all">
      <a href={YC_INTERVIEW_LINK} target="_blank" rel="noreferrer">
        <div className="h-full bg-gradient-to-t from-black/50 to-black/30 transition-all group-hover:from-black/[45%] group-hover:to-black/[25%]">
          <div className="flex h-full flex-col items-center justify-between gap-16 pb-16 text-center text-white">
            <div className="hidden sm:block" />
            <div className="transition-all group-hover:scale-105 ">
              <h4 className="hidden flex-col items-center gap-12 pt-20 text-[40px] leading-[48px] sm:flex sm:flex-row ">
                <PlaySolidIcon fill="white" className="h-40 w-40 " />
                Watch YC interview
              </h4>
              {/* Mobile */}
              <h4 className="flex max-w-xs flex-col items-center gap-12  pt-40 text-[40px] leading-[48px] sm:hidden sm:flex-row ">
                <PlaySolidIcon fill="white" className="h-40 w-40" />
                Watch <br />
                YC interview
              </h4>
            </div>
            <h5 className="hidden max-w-lg px-40 text-18-28 text-white/70 sm:block md:max-w-none ">
              CEO Raza Habib discusses with Y Combinator how to build
              differentiated products with LLMs
            </h5>
          </div>
        </div>
      </a>
    </div>
  );
};
